import { map } from 'lodash-es';

export default {

  /**
   * @param state
   * @returns {Array}
   */
  mapItineraryOverview(state) {
    const overviewList = state.overview.items;
    const productTypes = state.productTypes.items;
    const countries = state.masterCountries.items || [];

    return map(overviewList, (item) => {
      const index = productTypes.findIndex(productType => productType.id === item.productTypeId);
      const productType = productTypes[index];
      const itineraryCountryIds = item.tripCountryIds || [];
      const itemCountries = countries.filter(
        country => itineraryCountryIds.indexOf(country.id.toString()) !== -1,
      );
      return { ...item, productType: productType.name || null, countries: itemCountries };
    });
  },

  /**
   * @param state
   * @returns {Array}
   */
  getAvailableItinerarySalesCountries(state) {
    const masterCountries = state.masterCountries.items || [];
    const selected = state.salesCountries.items || [];
    const selectedIds = selected.map(country => country.id);
    return masterCountries.filter(country => selectedIds.indexOf(country.id) === -1);
  },

  /**
   * @param state
   * @returns {Array}
   */
  getAvailableItineraryTripThemes(state) {
    const elcanoTripThemes = state.tripThemes.items || [];
    const selected = state.assignedTripThemes.items || [];
    const selectedIds = selected.map(tripTheme => tripTheme.id);
    return elcanoTripThemes.filter(tripTheme => selectedIds.indexOf(tripTheme.id) === -1);
  },

  /**
   * @param state
   * @returns {Array}
   */
  mapItineraryTripCountries(state) {
    const countries = state.masterCountries.items || [];
    const itineraryCountryIds = state.edit.item.tripCountryIds || [];

    return countries.filter(item => itineraryCountryIds.indexOf(item.id.toString()) !== -1);
  },

  /**
   * @param state
   * @returns {Array}
   */
  getAvailableDayProgramHotels(state) {
    const hotels = state.dayProgramHotel.hotelsByArea || [];
    const selectedHotels = state.dayProgramHotel.selectedHotels || [];
    const selectedIds = selectedHotels.map(hotel => hotel.id);
    return hotels.filter(hotel => selectedIds.indexOf(hotel.id) === -1);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/itinerary/getters.js